import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';

export interface SquareErrorIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const SquareErrorIcon: FunctionComponent<SquareErrorIconProps> = ({
  className,
  ...props
}) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    className={className || ''}
    {...props}
  >
    <Background width="28" height="28" rx="4" ry="4" />
    <Path d="M15.39,14l2.35-2.35c.24-.24,.12-.75-.26-1.13-.38-.38-.89-.5-1.13-.26l-2.35,2.35-2.35-2.35c-.24-.24-.75-.12-1.13,.26s-.5,.89-.26,1.13l2.35,2.35-2.35,2.35c-.24,.24-.12,.75,.26,1.13,.38,.38,.89,.5,1.13,.26l2.35-2.35,2.35,2.35c.24,.24,.75,.12,1.13-.26s.5-.89,.26-1.13l-2.35-2.35Z" />
  </svg>
);

export default SquareErrorIcon;

const Background = styled.rect`
  fill: ${({ theme }) => theme.colors.iconBackground};
`;

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.error};
`;
